/**
 * Timeline: the blue line fills from the top as the milestones scroll by (GSAP ScrollTrigger, scrub, no pin).
 * The fill's head follows the middle of the screen, so it reaches a year badge as that badge passes the middle.
 * The markup is the finished state (fill at full height): without Nectar's GSAP, with ?still or reduced motion
 * (motionLib() is null) nothing runs and the line stays fully blue. Lenis drives ScrollTrigger (assets/js/lenis.ts),
 * and the left column's position: sticky needs no JS.
 * GSAP + ScrollTrigger: Nectar's (handle "gsap", listed before this file in block.json).
 */
import { motionLib } from '../../assets/js/motion';

const LINE_AT = 'center'; // the fill's head: this line of the screen

document.querySelectorAll<HTMLElement>('[data-px-block="timeline"]').forEach((wrapper) => {
	const lib = motionLib();
	const track = wrapper.querySelector<HTMLElement>('.timeline__track');
	const fill = wrapper.querySelector<HTMLElement>('[data-timeline-fill]');
	if (!lib || !track || !fill) {
		return;
	}
	const { gsap } = lib;

	gsap.fromTo(
		fill,
		{ scaleY: 0 },
		{
			scaleY: 1,
			ease: 'none',
			scrollTrigger: {
				trigger: track,
				start: `top ${LINE_AT}`,
				end: `bottom ${LINE_AT}`,
				scrub: true,
				invalidateOnRefresh: true,
			},
		}
	);
});
